import { graphql } from "gatsby"

export const BblFiftyFiftyFormBlockFragment = graphql`
  fragment BblFiftyFiftyFormBlock on WpBlock {
    ... on WpBblFiftyFiftyFormBlock {
      name
      attributes {
        heading
        className
      }
    }
  }
`

// This is the string version of this that is used within previews and without WP prefixes
export const BblFiftyFiftyFormBlockPreview = `
    ... on BblFiftyFiftyFormBlock {
        name
        attributes {
            heading
            className
        }
    }
`
